const settings: Record<string, {
    NODE_ENV: string,
    REACT_APP_HERE_API_KEY: string;
    API_URL: string;
    STORAGE_SECRET_KEY: string;
    VERSION: string
}> = {
    'production': {
        NODE_ENV: "prod",
        REACT_APP_HERE_API_KEY: "4fBT38vopEOMyDJRm2NMFFPn8wsOOh7d-nSfkr8m3bQ",
        API_URL: "https://api.shoopcity.com",
        STORAGE_SECRET_KEY: "SHOOPCITY_SECRET_PROD",
        VERSION: '1.0.4'
    },
    'staging': {
        NODE_ENV: "staging",
        REACT_APP_HERE_API_KEY: "4fBT38vopEOMyDJRm2NMFFPn8wsOOh7d-nSfkr8m3bQ",
        API_URL: "https://api-staging.shoopcity.com",
        STORAGE_SECRET_KEY: "SHOOPCITY_SECRET_DEV",
        VERSION: '1.0.5-test-1'
    },
    'development': {
        NODE_ENV: "dev",
        REACT_APP_HERE_API_KEY: "4fBT38vopEOMyDJRm2NMFFPn8wsOOh7d-nSfkr8m3bQ",
        API_URL: "https://api-dev.shoopcity.com",
        STORAGE_SECRET_KEY: "SHOOPCITY_SECRET_DEV",
        VERSION: '1.0.5-test-1'
    }
}

const config = settings[process.env.REACT_APP_STAGE] || {}


export default config
